module.exports = __webpack_public_path__ + "media/images/news-teaser-3f7a44bf0d0202ecfb2bae3a5e7a5c07.jpg";